<template>
  <div class="page_all">
    <div class="return_link"></div>
    <div class="page_header">
      <div class="header_title">
        <div class="title">お知らせ</div>
        <div class="message">
          <div class="error">{{ message }}</div>
        </div>
      </div>
      <!-- <div>
          <button @click="apiTest()">api test</button>
      </div> -->
      <div>
        <button class="btn_plus" @click="notificationAdd()">＋</button>
      </div>
    </div>
    <div class="page_main">
      <table class="tbl_main">
        <thead>
          <tr>
            <th class="th_title">タイトル</th>
            <th class="th_createDate">登録日</th>
            <th class="th_delete">削除</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="notification in notifications" v-bind:key="notification.notification_id">
            <td class="td_title">
              <router-link v-on:click.native="notificationUpdate(notification.notification_id)" to="">{{ notification.title }}</router-link>
            </td>
            <td class="td_createDate">
                {{ $moment(notification.create_date).format("YYYY年MM月DD日") }}
            </td>
            <td class="btn_delete">
              <button class="btn_delete" v-on:click="notificationDel(notification.notification_id)">X</button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <confirm-dialog ref="deleteDialog" primary-label="削除" secondary-label="キャンセル"/>
  </div>
</template>

<script>
// import { required, maxLength } from 'vuelidate/lib/validators'
import ConfirmDialog from "@/components/ConfirmDialog";

export default {
  components: {
    ConfirmDialog,
  },
  data: function() {
    return {
      notifications: null,
      // 以下モーダル変数
      showModal: false,
      // エラーメッセージ
      message: "",
      messageModal: "",
      updating: false,
    }
  },
  mounted() {
    this.getNotificationList()
  },
  methods: {
      async apiTest() {
       try {
            const response = await this.$axios.get(process.env.VUE_APP_API_BASEURL + 'v1/mytimeline/notifications', {
                params: {}
            })
            console.log(response.data)
        } catch (err) {
            this.message = err.response.data.errorMessage
        }
 
    },
    async getNotificationList() {
        try {
            const response = await this.$axios.get(process.env.VUE_APP_API_BASEURL + 'notification/list', {
                params: {}
            })
            this.notifications = response.data
        } catch (err) {
            this.message = err.response.data.errorMessage
        }
    },
    async notificationDel(notification_id) {
      const notification = this.notifications && this.notifications.find(notification => notification.notification_id === notification_id) || null;
      if (!notification) {
        return;
      }
      const result = await this.$refs.deleteDialog.asyncShow(`${notification.title}を削除してよろしいですか？`);
      if (!result) {
        return;
      }
      try {
        await this.$axios.post(process.env.VUE_APP_API_BASEURL + 'notification/del', {
          notification_id: notification_id,
        })
        this.getNotificationList()
      } catch (err) {
        this.message = err.response.data.errorMessage
      }
    },
    notificationAdd: function() {
      // 変更フラグ
      this.$store.commit('setStateChangeFlg', false)
      this.$router.push({ name: 'notificationDetail' })
    },
    notificationUpdate: function(notification_id) {
      // 変更フラグ
      this.$store.commit('setStateChangeFlg', true)
      this.$store.commit('setStateNotificationId', notification_id)
      this.$router.push({ name: 'notificationDetail' })
    },
	closeModal: function() {
      this.messageModal = ""
      this.showModal = false
      // validationsモデルオブジェクトをリセット
      this.$v.searchKeyword.$reset()
    }
  },
//   validations: {
//   }
}
</script>

<style scoped>
table th.th_createDate {
  width: 120px;
}
table th.th_delete {
  width: 30px;
}
table td.td_title {
  text-align: left;
  padding-left: 10px;
}
table td.td_createDate {
  border-left: none;
}
</style>